/**
 * 下单配置
 */
const PREFIX = "checkmall-system";
let systemApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    // 满意度列表
    qsaList: "/api/qsa/satisfaction/list",
    // 满意度新增
    qsaAdd: "/api/qsa/satisfaction/addData",
    // 中心概况详情
    ZxDetail: "/api/news/getZxDetail",
    /**订单步骤 */
    orderStep: "/api/step/getStep",
    // 新闻列表
    news: "/api/news/list",
    // 新闻/资质详情
    detaile: "/api/news/getDetail",
    // 标准服务详情
    bzDetail: "/api/technical/getBzDetail",
    // 技术服务list
    techList: "/api/technical/list",
    // 技术服务详情
    techDetail: "/api/technical/getDetail",
    // banner
    banners: "/api/banner/allList",
    // 关于平台
    getSys: "/api/system/getSystemInfo",
    // 用户指南树
    listTree: "/api/userGuide/listTree",
    // 用户指南详情
    guideList: "/api/userGuide/list",
    // 查询是否需要填写问卷（用于下载报告/数据时调用）
    getFirstReport: "/api/qsa/satisfaction/getFirstReport",
  },
};
export default systemApi;
